import { ITelemetry } from '@msdyn365-commerce/core';
import { useEffect } from 'react';

export interface IUseDataLayerTelemetryOptions {
    telemetry: ITelemetry;
}

/**
 * Patches window.dataLayer.push so purchase events are reported to telemetry
 * together with the consent status captured at mount time, mirroring the
 * legacy header behavior. The patch is page-global, applied at most once per
 * page via the window.__dataLayerTelemetryWrapped flag (shared with the
 * legacy header, so both can never double-patch), and is never removed.
 */
export const useDataLayerTelemetry = (options: IUseDataLayerTelemetryOptions): void => {
    const { telemetry } = options;

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }


        const dataLayer = (window.dataLayer = window.dataLayer || []);

        let consentStatus: { [key: string]: any } = {};

        // Prevent double-patching (flag shared with the legacy header).

        if ((window as any).__dataLayerTelemetryWrapped) {
            return;
        }

        (window as any).__dataLayerTelemetryWrapped = true;

        // Replay existing events
        for (const item of dataLayer) {
            if (item?.event) {
                if (item.event === 'consent_status') {

                    consentStatus = item;
                } else if (item.event === 'purchase') {
                    telemetry.error(`dataLayer event purchase (existing)`, {
                        'Google Analytics': consentStatus['Google Analytics'],
                        'Google Tag Manager': consentStatus['Google Tag Manager'],
                        'Microsoft Clarity': consentStatus['Microsoft Clarity'],
                        'Usercentrics Consent Management Platform': consentStatus['Usercentrics Consent Management Platform']
                    });
                }
            }
        }

        // Patch push to capture future events

        const originalPush = dataLayer.push;

        dataLayer.push = function (...args: any[]) {

            const result = originalPush.apply(dataLayer, args);

            try {
                for (const item of args) {

                    if (item?.event === 'purchase') {
                        telemetry.error(`dataLayer event purchase`, {
                            'Google Analytics': consentStatus['Google Analytics'],
                            'Google Tag Manager': consentStatus['Google Tag Manager'],
                            'Microsoft Clarity': consentStatus['Microsoft Clarity'],
                            'Usercentrics Consent Management Platform': consentStatus['Usercentrics Consent Management Platform']
                        });
                    }
                }
            } catch (err) {
                console.error('Telemetry logging failed:', err);
            }


            return result;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only, page-global patch.
    }, []);
};
